import { Component, Input, OnDestroy, ViewChild } from '@angular/core';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalService } from 'src/app/services/modal-service';

@Component({
  selector: 'modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent implements OnDestroy {
  @Input('css-class') public cssClass = '';

  @ViewChild('content', { static: true }) public content: any;

  private modal: NgbModalRef;

  public constructor(private modalService: ModalService) {
  }

  public open(closeable = true, backdrop:boolean | 'static' = true) {
    let backdropOverride:boolean | 'static';
    if(!closeable && backdrop) {
      backdropOverride = 'static';
    } else if (!closeable && backdrop !== true) {
      backdropOverride = backdrop;
    } else {
      backdropOverride = true;
    }

    this.modal = this.modalService.open(this.content, {
      windowClass: this.cssClass,
      ariaLabelledBy: 'modal-basic-title',
      centered: true,
      keyboard: closeable,
      backdrop: backdropOverride
    });
  }

  public close(reason?: string) {
    this.modal?.close(reason);
  }

  public ngOnDestroy() {
    if (this.modal != null) {
      this.modal = null;
    }
  }
}
